import { render, staticRenderFns } from "./amout_table.vue?vue&type=template&id=42d71dbc&scoped=true"
import script from "./amout_table.vue?vue&type=script&lang=js"
export * from "./amout_table.vue?vue&type=script&lang=js"
import style0 from "./amout_table.vue?vue&type=style&index=0&id=42d71dbc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d71dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d71dbc')) {
      api.createRecord('42d71dbc', component.options)
    } else {
      api.reload('42d71dbc', component.options)
    }
    module.hot.accept("./amout_table.vue?vue&type=template&id=42d71dbc&scoped=true", function () {
      api.rerender('42d71dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/reward_manage/incentive_budget/components/amout_table.vue"
export default component.exports